"use client";
import { noop } from "../noop/noop.mjs";
//#region packages/@mantine/core/src/core/utils/close-on-escape/close-on-escape.ts
function closeOnEscape(callback, options = { active: true }) {
	if (typeof callback !== "function" || !options.active) return options.onKeyDown || noop;
	return (event) => {
		if (event.key === "Escape") {
			callback(event);
			options.onTrigger?.();
		}
	};
}
//#endregion
export { closeOnEscape };

//# sourceMappingURL=close-on-escape.mjs.map